module.exports = __webpack_public_path__ + "img/agma2015-2-B15_fig01_radial-composite-deviation-50z.ed7ddc2e.png";